import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { IRecipient } from '@common/recipient';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { getRecipientSchema } from '@common/validation/utils/getRecipientSchema';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type BariPostDietPlanAppointmentData = {
    recipient: IRecipient;
    toelichting: string | null;
};

const bariPostDietPlanAppointmentFinal: TypedSchema<BariPostDietPlanAppointmentData> = {
    recipient: getRecipientSchema(),
    toelichting: getTextAreaStringSchema().allow(null),
};

const bariPostDietPlanAppointmentDraft: TypedSchema<BariPostDietPlanAppointmentData> = {
    recipient: getRecipientSchema(true, true),
    toelichting: getTextAreaStringSchema().allow(null),
};

export const bariPostDietPlanAppointmentDraftSchema = Koi.object(bariPostDietPlanAppointmentDraft);
export const bariPostDietPlanAppointmentFinalSchema = Koi.object(bariPostDietPlanAppointmentFinal);

export type BariPostDietPlanAppointmentReadKey = keyof BariPostDietPlanAppointmentData;

export type BariPostDietPlanAppointmentReadLabel = 'Toelichting' | 'Verstuurd naar';

export const bariPostDietPlanAppointmentReadSchema: TypedReadSchema<
    BariPostDietPlanAppointmentReadKey,
    BariPostDietPlanAppointmentReadLabel
>[] = [
    {
        items: [
            {
                key: 'recipient',
                label: 'Verstuurd naar',
            },
            {
                key: 'toelichting',
                label: 'Toelichting',
            },
        ],
    },
];
